<template>
  <div class="view-login">
    <v-navigation-drawer permanent absolute :width="512">
      <v-container fill-height>
        <v-form
          @submit.prevent="requestLogin"
          ref="form"
          :lazy-validation="true"
          class="flex-grow-1 d-flex flex-column align-stretch"
        >
          <v-img
            class="align-self-center mb-9"
            src="@/assets/adequation-logo-square.svg"
            :width="250"
            :height="250"
            alt="Adequation"
          />
          <header class="mb-12 text-center">
            <h1 class="display-1">
              {{ $t("Connexion") }}
            </h1>
          </header>
          <v-alert v-if="status == 'error'" type="error">
            {{ message }}
          </v-alert>
          <v-text-field
            v-model="email"
            :label="$t('Email')"
            hide-details
            filled
            type="email"
            validate-on-blur
            :rules="[rules.email, rules.required]"
            required
            class="mb-4"
          />
          <v-text-field
            v-model="password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('Mot de passe')"
            autocomplete="on"
            hide-details
            filled
            validate-on-blur
            :rules="[rules.required]"
            required
            @click:append="showPassword = !showPassword"
          />
          <div class="px-4">
            <v-checkbox
              v-model="stayLoggedIn"
              :label="$t('Rester connecté à Adequation')"
            />
          </div>
          <v-btn
            type="submit"
            :disabled="!validForm"
            :loading="loading"
            color="primary"
            large
            rounded
            class="align-self-center mb-9"
            >{{ $t("Se connecter") }}</v-btn
          >
          <span class="align-self-center">
            {{ $t("Vous n'avez pas votre mot de passe ?") }}
          </span>
          <v-btn
            class="align-self-center"
            text
            @click="
              () => {
                $router.push({ name: 'reset-password-general' });
              }
            "
            >{{ $t("Réinitialiser") }}</v-btn
          >

          <div class="env" :class="env">
            <div>{{ env }} <br />v{{ version }}</div>
          </div>
        </v-form>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { LOGIN } from "@/store/action-types";
import { version } from "../../package";
const {
  mapActions: mapAuthActions,
  mapState: mapAuthState
} = createNamespacedHelpers(`auth`);

export default {
  data() {
    return {
      env: process.env.VUE_APP_API_ENV,
      // version: process.env.VUE_APP_WEB_VERSION,
      version: version,
      validForm: true,
      email: "",
      password: "",
      showPassword: false,
      stayLoggedIn: false,
      rules: {
        required: value => !!value || this.$t("Requis."),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("Email invalide.");
        }
      }
    };
  },
  computed: {
    ...mapAuthState(["status", "message"]),
    loading() {
      return this.status == "loading";
    }
  },
  beforeMount() {
    if (this.$store.getters["auth/isLoggedIn"]) {
      this.redirectToHome();
    }
  },
  methods: {
    ...mapAuthActions({
      login: LOGIN
    }),
    requestLogin() {
      if (this.$refs.form.validate()) {
        this.login({
          email: this.email,
          password: this.password,
          stayLoggedIn: this.stayLoggedIn
        }).then(() => {
          this.redirectToHome();
        });
      }
    },
    redirectToHome() {
      let routerName = this.$store.getters["app/destinationRouterName"]
        ? this.$store.getters["app/destinationRouterName"]
        : "home";
      let routerParams = this.$store.getters["app/destinationRouterParams"]
        ? this.$store.getters["app/destinationRouterParams"]
        : {};
      this.$router.push({ name: routerName, params: routerParams });
    }
  }
};
</script>

<style lang="scss">
.view-login {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("~@/assets/login-background.jpg") no-repeat center right/cover;
}

.env {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgb(255, 255, 255);
  height: 96px;
  width: 96px;
  border-radius: 50%;

  position: absolute;
  left: 8px;
  bottom: 8px;
}

.LOCAL {
  background-color: #1ab5a9;
  opacity: 0.8;
}
.DEV,
.RCT {
  background-color: #4955bb;
  opacity: 0.8;
}
.PROD {
  background-color: rgb(255, 255, 255);
  visibility: hidden;
}
</style>
